// iPad の横向き幅以下なら true を返却する
export function isSideIpad(): boolean {
  return window.outerWidth <= 1024;
}
// iPad の縦向き幅以下なら true を返却する
export function isVerticalIpad(): boolean {
  return window.outerWidth <= 768;
}
